import React from 'react'
import LoadingIndicator from 'src/components/common/LoadingIndicator'
import SvgIcon from 'src/components/common/SvgIcon'
import CheckCircleIcon from 'src/assets/icons/check-circle.svg'
import styles from './image-item.scss'
import PropTypes from 'prop-types'

const ImageItem = ({ url, checked, alt, onClick }) => {
  const [loading, setLoading] = React.useState(true)

  return (
    <div
      className={`${styles['image-item']} ${checked ? styles['image-item-checked'] : ''}`}
      onClick={onClick}
      style={{ position: 'relative' }}
    >
      {loading && (
        <div className={styles['loading-container']}>
          <LoadingIndicator />
        </div>
      )}
      <img
        src={url}
        alt={alt}
        loading="lazy"
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          objectPosition: 'center',
          objectFit: 'cover',
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.2s'
        }}
        onLoad={() => setLoading(false)}
      />
      {checked && (
        <SvgIcon className={styles['check-icon']} icon={CheckCircleIcon} />
      )}
    </div>
  )
}

ImageItem.propTypes = {
  url: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  alt: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default ImageItem
